import React from 'react';
import {FileLoaderType, FileResult} from './BaseFileLoader';
import ImageFileLoader from './ImgFileLoader';
import NblFileLoader from './NblFileLoader';
import VideoFileLoader from './VideoFileLoader';

interface HighlightedInputMediaProps {
    onLoad: (files: FileResult[]) => void;
    type: FileLoaderType;
    multipleFiles?: boolean;
    child?: JSX.Element;
    hasExistingFile?: boolean;
    inputRef?: React.RefObject<HTMLInputElement>;
}

function HighlightedInputMedia(props: HighlightedInputMediaProps): JSX.Element {
    const {onLoad, type, multipleFiles, child, hasExistingFile, inputRef} = props;

    if (type === 'nbl') {
        return <NblFileLoader inputRef={inputRef} onLoad={onLoad} multipleFiles={multipleFiles} child={child} />;
    }

    if (type === 'video') {
        return (
            <VideoFileLoader
                inputRef={inputRef}
                onLoad={onLoad}
                multipleFiles={multipleFiles}
                child={child}
                hasExistingVideo={hasExistingFile}
            />
        );
    }

    return (
        <ImageFileLoader
            inputRef={inputRef}
            onLoad={onLoad}
            multipleFiles={multipleFiles}
            child={child}
            hasExistingImage={hasExistingFile}
        />
    );
}

export default HighlightedInputMedia;
